module.exports = "<div *ngIf='utils.isAdmin'>\n\n  <div *ngIf='isNewProject'>\n    <h1>New project</h1>\n    <app-project-box [isEdit]='true'></app-project-box>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/admin-page/admin-page.component.html
// module id = ../../../../../src/app/admin-page/admin-page.component.html
// module chunks = main